import Loading from './full-screen-loader';
export default Loading;
